import { render } from "./LoginPage.vue?vue&type=template&id=48b0550c&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=48b0550c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b0550c"]])

export default __exports__